import {
  GET_ALL_USER_SUCCESS,
  GET_ALL_USER_FAILURE,
  CREATE_USER_FAILURE,
  CREATE_USER_SUCCESS,
  CREATE_USER,
  FETCH_USER,
  GET_USER_SUCCESS,
  GET_USER_FAILURE,
  UPDATE_USER,
  UPDATE_USER_FAILURE,
  UPDATE_USER_SUCCESS,
  FETCH_ALL_USERS,
  CHECK_USER,
  CHECK_USER_FAILURE,
  CHECK_USER_SUCCESS,
  LOG_OUT,
} from "../constant";

const initState = {
  getUser: {
    success: false,
    error: "",
    user: {},
    isFetched: false,
  },
  getAllUsers: {
    success: false,
    error: "",
    users: [],
    isFetched: false,
  },
  createUser: {
    success: false,
    error: "",
    message: "",
    isPost: false,
  },
  updateUser: {
    success: false,
    error: "",
    message: "",
    isPost: false,
  },
  checkUser: {
    success: false,
    error: "",
    checkUser: {},
    isFetched: false,
  },
};

export default function createcheckup(state = initState, action) {
  switch (action.type) {
    case FETCH_USER:
      return {
        ...state,
        getUser: {
          success: false,
          error: "",
          user: {},
          isFetched: false,
        },
      };
    case GET_USER_SUCCESS:
      return {
        ...state,
        getUser: {
          success: action.payload.success,
          user: action.payload.user,
          error: "",
          isFetched: true,
        },
      };

    case GET_USER_FAILURE:
      return {
        ...state,
        getUser: {
          success: false,
          error: action.payload.error,
          user: {},
          isFetched: true,
        },
      };

    case FETCH_ALL_USERS:
      return {
        ...state,
        getAllUsers: {
          success: false,
          error: "",
          users: [],
          isFetched: false,
        },
      };
    case GET_ALL_USER_SUCCESS:
      return {
        ...state,
        getAllUsers: {
          success: action.payload.success,
          users: action.payload.users,
          error: "",
          isFetched: true,
        },
      };
    case GET_ALL_USER_FAILURE:
      return {
        ...state,
        getAllUser: {
          success: false,
          error: action.payload.error,
          users: [],
          isFetched: true,
        },
      };

    case CREATE_USER:
      return {
        ...state,
        createUser: {
          success: false,
          error: "",
          message: "",
          isPost: false,
        },
      };
    case CREATE_USER_SUCCESS:
      return {
        ...state,
        createUser: {
          success: action.payload.success,
          message: action.payload.message,
          error: "",
          isPost: true,
        },
      };
    case CREATE_USER_FAILURE:
      return {
        ...state,
        createUser: {
          success: false,
          error: action.payload.error,
          message: "",
          isPost: true,
        },
      };

    case UPDATE_USER:
      return {
        ...state,
        updateUser: {
          success: false,
          error: "",
          message: "",
          isPost: false,
        },
      };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        updateUser: {
          success: action.payload.success,
          message: action.payload.message,
          error: "",
          isPost: true,
        },
      };
    case UPDATE_USER_FAILURE:
      return {
        ...state,
        updateUser: {
          success: false,
          error: action.payload.error,
          message: "",
          isPost: true,
        },
      };

    case CHECK_USER:
      return {
        ...state,
        checkUser: {
          success: false,
          error: "",
          checkUser: {},
          isFetched: false,
        },
      };
    case CHECK_USER_SUCCESS:
      return {
        ...state,
        checkUser: {
          success: action.payload.success,
          checkUser: action.payload.checkUser,
          error: "",
          isFetched: true,
        },
      };
    case CHECK_USER_FAILURE:
      return {
        ...state,
        checkUser: {
          success: false,
          error: action.payload.error,
          checkUser: {},
          isFetched: true,
        },
      };
    case LOG_OUT:
      return {
        initState,
      };
    default:
      return state;
  }
}
